module.exports = __webpack_public_path__ + "img/icon_FAQ.8fb86a09.png";